var convert = require('./convert'),
    func = convert('sortBy', require('../sortBy'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash/fp/sortBy.js
// module id = 1581
// module chunks = 92